/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_ITEM (state, item) {
    state.invitationList.unshift(item)
  },
  SET_PRODUCTS (state, products) {
    state.invitationList = products
  },
  // SET_LABELS(state, labels) {
  //   state.eventLabels = labels
  // },
  UPDATE_PRODUCT (state, product) {
    const productIndex = state.invitationList.findIndex((p) => p.id === product.id)
    Object.assign(state.invitationList[productIndex], product)
  },
  REMOVE_ITEM (state, itemId) {
    const ItemIndex = state.invitationList.findIndex((p) => p.id === itemId)
    state.invitationList.splice(ItemIndex, 1)
  }
}
